import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
    title: {
    },
    subTitle: {
    },
    openingDateTextContainer: {
        flexDirection: 'row',
        marginTop: 8
    },
    countDownTimeRowContainer: {
        marginTop: 16,
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '90%'
    },
    countDownTimeColumnContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        width: '20%'
    },
    countDownTimeValueText: {
        fontWeight: 'bold'
    },
    countDownTimeText: {
        fontWeight: 'bold'
    },
    textWhite: {
        color: 'white',
        fontFamily: 'Montserrat',
    }
});